import React, { useEffect, useState, Fragment } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import DataTable from 'react-data-table-component';
import { Row, Col, Card, CardBody, Button, ModalHeader, ModalBody, ModalFooter, Modal, Input, Label, FormGroup, Form } from "reactstrap";
import AuthService from "../Authentication/auth.service.js";
import { useTranslation } from 'react-i18next';
import LoadingOverlay from "react-loading-overlay-ts";
import fileDownload from 'js-file-download'
import DNALoader from "../../components/Loaders/DnaLoader.js";
import "../../assets/custom css/loadoverlay.scss";
import Alerts from "../../components/Alerts/alerts.js";
import Services from "./services.js";
import QuotationsFilter from "../../components/Table Filters/DoctorFilter.js";
import styled from 'styled-components';
import PermissionAccess from '../../PermissionAccess/Access.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash, faEye } from '@fortawesome/free-solid-svg-icons';
import Tooltip from '@mui/material/Tooltip';
import moment from "moment";
import UpdateStatus from '../Order/UpdateStatus.js';
import add_new_rfq from './add_new_rfq.js';
import AlertService from "../../components/Alerts/alerts.js";

const customStyles = {
  rows: {
    style: {
      minHeight: '32px', // override the row height
    }
  },
  cells: {
    style: {
      paddingLeft: '8px', // override the cell padding for data cells
      paddingRight: '8px',
    },
  },
};
const conditionalRowStyles = [
  {
    when: row => row.return_status === 'pending',
    style: {
      backgroundColor: '#FFFFE0',
      '&:hover': {
        cursor: 'pointer',
      },
    },
  },
];



const QuotationsListing = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [Customers, setCustomers] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [filterText, setFilterText] = useState('');
  const [filterStatus, setFilterStatus] = useState('');
  const { authData, accessPages, super_admin, current_module } = PermissionAccess();
  const [QuotationsToEdit, setQuotationsToEdit] = useState(null);
  const [totalRows, setTotalRows] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(0);
  const [modal, setModal] = useState(false);
  const [warehouses, setWarehouses] = useState([]);
  const [selectedWarehouse, setSelectedWarehouse] = useState('');
  const [csvFile, setCsvFile] = useState(null);
  const [Fetched_Businesses, setFetched_Businesses] = useState([]);
  const [showModalUpdateStatus, setshowModalUpdateStatus] = useState(false);
  const [array, setArray] = useState([]);

  const handleToggleModalUpdateStatus = (row) => {
    // Prevent changing status once cancelled (same behavior as delivered)
    try {
      const currentStatus = (row?.status || '').toLowerCase();
      if (currentStatus === 'cancelled') {
        AlertService.swalErrorAlert(t('Cancelled orders cannot be updated.'));
        return;
      }
    } catch (_) { /* no-op */ }
    setArray(row);
    setshowModalUpdateStatus(!showModalUpdateStatus);
  }

  function HandleDeleteOrder(row) {
    // Do not allow delete for cancelled orders
    if ((row?.status || '').toLowerCase() === 'cancelled') {
      AlertService.swalErrorAlert(t('Cancelled orders cannot be deleted.'));
      return;
    }
    let msg = t("Are you sure you want to delete this order")
    Alerts.swalConfirmDeleteAlert(msg).then(res => {
      //iph todo: 47
      //console.log("Resp:-", res)
      if (res === true) {
        sendDelete(row._id)
      }
    })
  };

  function sendDelete(_id) {
    setLoading(true);
    Services.DeleteOrder(_id).then((response) => {
      setLoading(false);
      //iph todo: 47
      //console.log("Delete customer response:-", response)
      if (response.data.status) {
        fetchOrders(currentPage, pageLimit)
        if (response.data.message !== '') {
          Alerts.swalSuccessAlert(response.data.message)
        }
        else {

          //iph todo: 47
          //console.log(response);
          setLoading(false);
          Alerts.swalSuccessAlert(t("Order Deleted Successfully."))
        }
        //iph todo: 47
        //console.log(response.data.message)
      }
      else {
        if (response.data.message !== '') {
          if (response.data.message === "Unauthorized") {
            AuthService.logout();
            navigate("/login");
            window.location.reload();
          }
          else {
            Alerts.swalErrorAlert(response.data.message);
          }
        }
        else {
          Alerts.swalErrorAlert(t("Error: Can't delete the customer at the moment."))
        }
      }
    },
      (error) => {
        setLoading(false);
        const errContent =
          (error.response && error.response.data) || error.message || error.toString();
        Alerts.swalErrorAlert(t("Delete operation failed"))
      })
  };

  useEffect(() => {
    i18n.changeLanguage(localStorage.getItem('language'));
    fetchWarehouses();
    Fetch_Businesses();
    fetchOrders(currentPage, pageLimit, filterText, filterStatus);
  }, [pageLimit, i18n]);


  function Fetch_Businesses() {
    setLoading(true);
    Services.GetBusinesses(authData.sessionID).then(
      (response) => {
        setLoading(false);
        if (response.data.message === "Unauthorized") {
          AuthService.logout();
          navigate("/login");
          window.location.reload();
        } else {
          const business = response.data.data[0];
          //iph todo: 47
          //console.log("business", business)
          setFetched_Businesses(business);
        }
      },
      (error) => {
        setLoading(false);
        const errContent =
          (error.response && error.response.data) ||
          error.message ||
          error.toString();
        Alerts.swalErrorAlert(errContent || t("Server Error, Please try again later."));
      }
    );
  }



  const fetchWarehouses = () => {
    Services.GetWarehouses(authData.sessionID)
      .then((response) => {
        if (response.data.status) {
          setWarehouses(response.data.data);
        } else {
          Alerts.swalErrorAlert(response.data.message || t("Error fetching warehouses."));
        }
      })
      .catch((error) => {
        Alerts.swalErrorAlert(t("Failed to fetch warehouses"));
      });
  };
  const handleWarehouseChange = (e) => {
    setSelectedWarehouse(e.target.value);
  };




  // const fetchOrders = (page, limit, text, status) => {
  //   const offset = (page - 1) * limit;
  //   const getData = {
  //     functionName: "GetCustomers",
  //     postData: {
  //       offset,
  //       filterStatus: status,
  //       filterText: text,
  //       sort: { _id: -1 },
  //       limit,
  //       business_id: authData.userData.businesses || []
  //     }
  //   };

  //   setLoading(true);
  //   Services.GetCustomers(authData.sessionID, getData)
  //     .then((response) => {
  //       setLoading(false);
  //       if (response.data.message === "Unauthorized") {
  //         AuthService.logout();
  //         navigate("/login");
  //       } else {
  //         setCustomers(response.data.data);
  //         setTotalRows(response.data.count.count);
  //       }
  //     })
  //     .catch((error) => {
  //       setLoading(false);
  //       Alerts.swalErrorAlert(t("Server Error, Please try again later."));
  //     });
  // };

  function fetchOrders(page_index, page_limit, filterText, filterStatus) {
    var offset = (page_index - 1) * page_limit;
    if (offset < 1) {
      offset = 0;
    }
    const stored_user = authData.userData;
    let business = []
    if (stored_user.businesses) {
      business = stored_user.businesses
    }
    var payload = {
      functionName: "Get_Admin_RFQs",
      postData: {
        filter: {},
        filterStatus: filterStatus,
        filterText: filterText,
        limit: page_limit,
        offset: offset,
        business: [],
        order_for: 'doctor'
      }
    }

    setLoading(true);
    Services.Get_Admin_RFQs(authData.sessionID, payload).then((response) => {
      setLoading(false);
      //iph todo: 47
      //console.log("Get Quotations response:-", response)
      if (response.data.message === "Unauthorized") {
        AuthService.logout();
        navigate("/login");
        window.location.reload();
      }
      else {
        setCustomers(response.data.data);
        //iph todo: 47
        //console.log("Responsse", response.data);
        setTotalRows(response.data.counts.count);
      }
    },
      (error) => {
        setLoading(false);
        const errContent =
          (error.response && error.response.data) || error.message || error.toString();
        //iph todo: 47
        //console.log("Net:-", errContent)
        if (errContent) {
          Alerts.swalErrorAlert(errContent)
        }
        else {
          Alerts.swalErrorAlert(t("Server Error, Please try again later."))
        }
      })
  };
  const handleSuccess = () => {
    fetchOrders(currentPage, pageLimit, filterText, filterStatus);
  };

  const confirmDelete = (id) => {
    Alerts.swalConfirmDeleteAlert(t("Once deleted, you will not be able to recover this Record!"))
      .then(res => {
        if (res) {
          deleteQuotations(id);
        }
      });
  };


  const ViewDetails = (id) => {
    navigate(`/quotation_details`, { state: { id } });
  }

  const deleteQuotations = (id) => {
    setLoading(true);
    Services.DeleteQuotations(authData.sessionID, id)
      .then((response) => {
        setLoading(false);
        if (response.data.status) {
          Alerts.swalSuccessAlert(response.data.message || t("Data Deleted Successfully."));
          fetchOrders(currentPage, pageLimit, filterText, filterStatus);
        } else {
          if (response.data.message === "Unauthorized") {
            AuthService.logout();
            navigate("/login");
          } else {
            Alerts.swalErrorAlert(response.data.message || t("Error: Can't delete at the moment."));
          }
        }
      })
      .catch((error) => {
        setLoading(false);
        Alerts.swalErrorAlert(t("Delete operation failed"));
      });
  };

  const handleDeleteSelected = () => {
    if (selectedRows?.length > 0) {
      Alerts.swalConfirmDeleteAlert(t(selectedRows?.length + " records selected. Once deleted, you will not be able to recover this!"))
        .then(res => {
          if (res) {
            deleteBulkCustomers(selectedRows);
          }
        });
    } else {
      Alerts.swalErrorAlert('No records selected');
    }
  };

  const deleteBulkCustomers = (ids) => {
    setLoading(true);
    Services.DeleteBulkQuotations(authData.sessionID, ids)
      .then((response) => {
        setLoading(false);
        setSelectedRows([]);
        if (response.data.status) {
          Alerts.swalSuccessAlert(response.data.message || t("Data Deleted Successfully."));
          fetchOrders(currentPage, pageLimit, filterText, filterStatus);
        } else {
          if (response.data.message === "Unauthorized") {
            AuthService.logout();
            navigate("/login");
          } else {
            Alerts.swalErrorAlert(response.data.message || t("Error: Can't delete the Collection Data at the moment."));
          }
        }
      })
      .catch((error) => {
        setLoading(false);
        Alerts.swalErrorAlert(t("Delete operation failed"));
      });
  };
  const handleSelectAllChange = (e) => {
    if (e.target.checked) {
      setSelectedRows(Customers.map(Quotations => Quotations._id));
    } else {
      setSelectedRows([]);
    }
  };
  const getStatusColor = (status) => {
    switch (status.toLowerCase()) {
      case 'pending':
        return '#FFA500'; // Orange
      case 'confirmed':
        return 'green'; // green
      case 'accepted':
        return '#4169E1'; // Royal Blue
      case 'processing':
        return '#9370DB'; // Medium Purple
      case 'in_transit':
        return '#1E90FF'; // Dodger Blue
      case 'delivered':
        return '#32CD32'; // Lime Green
      case 'cancelled':
      case 'rejected':
        return '#DC143C'; // Crimson
      case 'issued':
        return '#228B22'; // Forest Green
      case 'review':
        return '#FF4500'; // Orange Red
      case 'Back Order':
        return '#FF8C00'; // Dark Orange
      default:
        return '#808080'; // Gray for unknown status
    }
  };
  const columns = [
    { name: 'Order ID', selector: row => row?.order_number ? row?.order_number : row?.rfq_id, sortable: true },
    { name: 'Order ID', selector: row => row?.rfq_id ? row?.rfq_id : '', sortable: true },
    {
      name: 'Doctor Name',
      selector: row => `${row?.userDetails?.name} (${row?.userDetails?.clinic_name || 'N/A'})`,
      sortable: true,
      cell: row => (
        <Tooltip title={`${row?.userDetails?.name} (${row?.userDetails?.clinic_name || 'N/A'})`} arrow>
          <span>{`${row?.userDetails?.name} (${row?.userDetails?.clinic_name || 'N/A'})`}</span>
        </Tooltip>
      )
    },
    {
      name: 'Doctor Address',
      selector: row => `${row?.userDetails?.Address || 'N/A'})`,
      sortable: true,
      cell: row => (
        <Tooltip title={`${row?.userDetails?.Address || 'N/A'})`} arrow>
          <span>{`${row?.userDetails?.Address || 'N/A'}`}</span>
        </Tooltip>
      )
    },
    { name: 'Date of Order', selector: row => moment(row?.datetime_added).format('DD-MM-YYYY'), sortable: true },
    { name: 'Quotation Date', selector: row => row?.quotation_date ? moment(row?.quotation_date).format('DD-MM-YYYY hh:mm:ss A') : 'N/A', sortable: true },
    { name: 'Total Item', selector: row => row?.items?.length, sortable: true },
    {
      name: 'Status',
      selector: row => row?.status.charAt(0).toUpperCase() + row?.status.slice(1),
      sortable: true,
      cell: row => {
        const capitalizedStatus = row?.status.charAt(0).toUpperCase() + row?.status.slice(1);
        return (
          <span style={{
            color: getStatusColor(row?.status),
            fontWeight: 'bold',
          }}>
            {capitalizedStatus}
          </span>
        );
      }
    },
    {
      name: t("Actions"),
      width: '150px',
      minWidth: '150px',
      wrap: true,
      allowOverflow: false,
      ignoreRowClick: true,
      button: true,
      selector: (row) => {
        return (
          <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: '6px', maxWidth: '150px' }}>
            {(super_admin || current_module?.ViewData === 1) && (
              <Tooltip title={t("Verify Invoice")}>
                <i onClick={() => ViewDetails(row?._id)} className="pe-7s-note2 btn-icon-wrapper text-primary"> </i>
              </Tooltip>
            )}
            {/* Add Edit Order button for admin, like doctor side */}
            {((row?.status === 'requested') || (row?.status === 'Back Order') || (row?.status === 'rejected')) && (
              <Tooltip placement="top" title={t("Edit Order")} arrow>
                <button className="btn btn-link p-0" onClick={() => navigate(`/edit_rfqs/${row._id}`, { state: { from: 'quotations' } })}>
                  <i className="pe-7s-pen text-primary btn-icon-wrapper fs-5 p-1" style={{ fontSize: '1.2rem' }}></i>
                </button>
              </Tooltip>
            )}
            {row?.return_status === 'pending' && (super_admin || current_module?.ReturnItems === 1) && row?.status.toLowerCase() === "delivered" && (
              <Tooltip title={t("Return Items")}>
                <button className="btn btn-link p-0" onClick={() => navigate(`/return_items_admin/${row._id}`)} >
                  <i className="pe-7s-refresh text-success" style={{ fontSize: '1.2rem' }}></i>
                </button>
              </Tooltip>
            )}
            {(row?.status === 'requested' || row?.status === 'Back Order') && (
              !super_admin ? current_module?.DeleteData === 1 &&
                <Tooltip placement="top" title={`${t("Delete")} ${t("Order")}`} arrow>
                  <i
                    className="pe-7s-trash text-danger btn-icon-wrapper fs-5 p-1"
                    style={{ cursor: 'pointer' }}
                    onClick={() => confirmDelete(row?._id)}
                  > </i>
                </Tooltip>
                :
                <Tooltip placement="top" title={`${t("Delete")} ${t("Order")}`} arrow>
                  <i
                    className="pe-7s-trash text-danger btn-icon-wrapper fs-5 p-1"
                    style={{ cursor: 'pointer' }}
                    onClick={() => confirmDelete(row?._id)}
                  > </i>
                </Tooltip>
            )}
            {row?.status.toLowerCase() !== "delivered" && row?.status.toLowerCase() !== "requested" && row?.status.toLowerCase() !== "Back Order" && row?.status.toLowerCase() !== "rejected" && row?.status.toLowerCase() !== "Review" && row?.status.toLowerCase() !== "cancelled" && (
              !super_admin ? current_module?.EditData === 1 &&
                <Tooltip placement="top" title={`${t("Update")} ${t("Status")}`} arrow>
                  <i
                    className="pe-7s-tools btn-icon-wrapper text-primary fs-5 p-1"
                    style={{ cursor: 'pointer' }}
                    onClick={() => handleToggleModalUpdateStatus(row)}
                  > </i>
                </Tooltip>
                :
                <Tooltip placement="top" title={`${t("Update")} ${t("Status")}`} arrow>
                  <i
                    className="pe-7s-tools btn-icon-wrapper text-primary fs-5 p-1"
                    style={{ cursor: 'pointer' }}
                    onClick={() => handleToggleModalUpdateStatus(row)}
                  > </i>
                </Tooltip>
            )}
            {/* Hide delete action for cancelled orders */}
          </div>
        );
      }
    }
  ]


  const handlePageChange = (page) => {
    setCurrentPage(page);
    fetchOrders(page, pageLimit, filterText, filterStatus);
  };

  const handlePerRowsChange = async (newLimit, page) => {
    setPageLimit(newLimit);
  };

  const handleSearch = (searchText, status) => {
    setFilterText(searchText);
    setFilterStatus(status);
    fetchOrders(0, pageLimit, searchText, status);
  };

  const handleClear = () => {
    setFilterText('');
    setFilterStatus('');
    fetchOrders(0, pageLimit, '', '');
  };



  const toggleModal = () => {
    setModal(!modal);
  };

  const subHeaderComponentMemo = React.useMemo(() => (
    <QuotationsFilter
      onSearch={handleSearch}
      onClear={handleClear}
      filterText={filterText}
      filterStatus={filterStatus}
    />
  ), [filterText, filterStatus]);

  return (
    <Fragment>
      <div className="app-main__outer">
        <div className="app-main__inner">
          <div className="bg-light-gray bg-animation">
            <div className="d-flex justify-content-center align-items-center">
              <Col md="12" className="mx-auto app-login-box">
                <UpdateStatus
                  showModalUpdateStatus={showModalUpdateStatus}
                  handleToggleModalUpdateStatus={handleToggleModalUpdateStatus}
                  onSuccess={fetchOrders}
                  array={array}
                />
                <div className="app-page-title mb-3">
                  <div className="page-title-wrapper">
                    <div className="page-title-heading fw-bold">
                      <div className="page-title-icon">
                        <i className="pe-7s-note2 icon-gradient bg-tempting-azure" />
                      </div>
                      <div>
                        {t("Orders")}
                        <div className="page-title-subheading">
                          {t("View Basic and detailed information of ")} {t("Orders")}
                        </div>
                      </div>
                    </div>
                    <div className="page-title-actions">
                      <button type="button" onClick={() => navigate(-1)} className="btn btn-outline-success btn-hover-shine me-3">
                        {t("Back")}
                      </button>
                    </div>
                  </div>
                </div>

                <Card className="main-card mb-3">
                  <CardBody>
                    <LoadingOverlay active={loading} spinner={<DNALoader />}>
                      <Row className="mb-3">
                        <Col md="8">
                          {subHeaderComponentMemo}
                        </Col>
                        <Col md="4" className="text-end">
                          {(super_admin || current_module?.BulkDeleteData === 1) && (
                            <>
                              <Button color="primary" onClick={() => { navigate('/add_quotation_admin') }} className="me-2">
                                {t('Add Quotation')}
                              </Button>
                              <Button color="danger" onClick={() => { navigate('/add_order_admin') }} className="me-2">
                                {t('Add Order')}
                              </Button>
                            </>
                          )}
                          {/* {(super_admin || current_module?.AddData === 1) && ( */}
                          {/* <add_new_rfq onSuccess={handleSuccess} warehouses={warehouses} /> */}
                          {/* )} */}
                          {/* {(super_admin || current_module?.ImportCSV === 1) && (
                            <button type="button" className="btn btn-custom-color btn-hover-shine me-3 btn ImportData" onClick={toggleModal}>{t('Bulk Quotations In')}</button>
                          )}  */}
                        </Col>
                      </Row>
                      <DataTable
                        columns={columns}
                        data={Customers}
                        pagination
                        paginationServer
                        paginationTotalRows={totalRows}
                        onChangePage={handlePageChange}
                        onChangeRowsPerPage={handlePerRowsChange}
                        customStyles={customStyles}
                        conditionalRowStyles={conditionalRowStyles}
                      />
                    </LoadingOverlay>
                  </CardBody>
                </Card>
              </Col>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default QuotationsListing;